import EXPPopupJs from 'components/common/exp-popupjs';
import { IS_IN_APP_WEBVIEW_BROWSER } from 'constants/default-config';
import { clearUserLocalStorage } from 'helpers';
import cryptojs from 'helpers/cryptoJs';
import { browserName, isIOS, isMobile, osVersion } from 'react-device-detect';
import { StandardResponse } from '.';
import { DecodeFromData } from 'type.global';
import { paramsToObject } from 'hooks/useQueryParams';

export function handlePharmcareError(
    json: StandardResponse<any>,
    reject: (reason: any) => void,
    requestPath?: string,
    getValidateToken?: (redirectPath?: string) => void
) {
    let redirectPath = '/user/line?to=';

    if (json?.userProfile?.userType === 'EMAIL') {
        redirectPath = '/user/login?to=';
    }
    if (json?.userProfile?.userType === 'SSO') {
        const userSsoProfile = json?.userProfile?.userSsoProfile;
        redirectPath = `/user/sso?sfssoid=${userSsoProfile?.svcId}&accname=${userSsoProfile?.accName}&pcparam=`;
    }

    // return
    // if not some in array return
    if (
        [401, 407, 417, 500].every((s) => json.statusCode !== s) ||
        (json.statusCode === 408 && ['/service/telepharmacy', '/service/telemed'].every((e) => window.location.pathname === e))
    ) {
        reject({ ...json, isNoPopup: true });
    }
    if ([401, 407, 417, 500].some((s) => json.statusCode === s)) {
        reject({ ...json, isNoPopup: false });
    }

    // Unauthorized
    if (json.statusCode === 401) {
        console.error(json);
        const from = {
            path: window.location.pathname,
            params: window.location.search,
        };
        //
        // reject(json)

        EXPPopupJs.alert({
            type: 'warning',
            icon: 'warning',
            title: 'เกิดข้อผิดพลาด',
            message: 'Unauthorized401 User',
            classNames: { message: 'font-detail2' },
            buttons: [
                {
                    label: 'ตกลง',
                    variant: 'primary',
                    action: () => {
                        if (getValidateToken && requestPath !== '/user/validateToken') {
                            //call เพื่อให้เกิด 408 เอาข้อมูล theme เพื่อดีดต่อไป /user/line
                            //ในรอบแรก แต่ถ้า call แล้วเจอ 401 อีกให้ clear แบบปกติ
                            getValidateToken(redirectPath);
                        } else {
                            clearUserLocalStorage();
                            window.location.assign(redirectPath + cryptojs.encode(from));
                        }
                    },
                },
            ],
        });

        if (requestPath === '/user/validateToken') reject({ ...json, isNoPopup: false });
    }

    // Forbidden Signup
    if (json.statusCode === 403) {
        console.error(json);
        //
        // reject(json)
        let encodeParams = '';
        let from: DecodeFromData = {
            path: '/',
            params: '',
        };
        const query = paramsToObject(window.location.search);
        //
        if (window.location.pathname.startsWith('/user/sso') && query.pcparam) {
            const decodeParams = cryptojs.decode(query.pcparam);

            if (!isMobile && decodeParams?.data?.userType === 'SSO') {
                redirectPath = window.location.href;
            } else if (
                decodeParams?.data?.partner === '34' &&
                decodeParams?.data?.userType === 'SSO' &&
                isMobile &&
                !(isIOS && osVersion <= '14.3.0') &&
                !IS_IN_APP_WEBVIEW_BROWSER.some((e) => e === browserName) &&
                window.location.pathname.startsWith('/user/sso')
            ) {
                let nextPath = window.location.href;
                let url = window.encodeURIComponent(nextPath);

                const pharmcarePath = url;
                // redirectPath =
                //     'https://workplaze.page.link/?link=https://workplaze.page.link/' +
                //     pharmcarePath +
                //     '&apn=com.hmc.workplaze&isi=1637565364&ibi=com.hmc.workplaze'
                redirectPath =
                    'workplaze://myplaze/marketplace/health?link=' +
                    pharmcarePath +
                    '&apn=com.hmc.workplaze&isi=1637565364&ibi=com.hmc.workplaze';
            }
        } else if (
            json?.data?.userXPartner &&
            json?.data?.userXPartner.partnerTheme === 'workplaze' &&
            isMobile &&
            !IS_IN_APP_WEBVIEW_BROWSER.some((e) => e === browserName) &&
            json?.data?.userType === 'SSO'
        ) {
            from = {
                path: '/phr/existing',
                data: {
                    partner: '34',
                    userType: 'SSO',
                    authorization: null,
                    userId: null,
                    autoLogin: '1',
                    companyCode: '',
                    language: 'TH',
                    rich: null,
                },
            };

            if (query.pcparam) {
                from = {
                    ...from,
                    ...cryptojs.decode(query.pcparam),
                };
            }
            if (query?.language) {
                from = {
                    ...from,
                    data: {
                        ...from.data,
                        language: query.language?.toLocaleUpperCase(),
                    },
                };
            }
        } else if (window.location.pathname === '/line/redirect') {
            let to = query?.to || '';

            if (query['liff.state']) {
                const decodeUri = window.decodeURIComponent(query['liff.state']);
                const liffState = paramsToObject(decodeUri);

                to = liffState?.to || '';
            }

            if (cryptojs.isEncode(to)) {
                const decodeParams = cryptojs.decode(to);

                from = {
                    path: decodeParams.path,
                    params: decodeParams.params,
                    data: {
                        ...decodeParams?.data,
                        authorization: null,
                    },
                };
            }
        } else if (window.location.pathname === '/partner20/redirect/user-plugin') {
            const decodeLineState = cryptojs.decode(json?.data?.lineState);
            let paramsLiffState = window.location.search;

            if (query['liff.state']) {
                paramsLiffState = window.decodeURIComponent(query['liff.state']);
            }

            from = {
                path: '/tlm/claim',
                params: paramsLiffState,
                data: {
                    ...decodeLineState?.data,
                    partner: '20',
                    autoLogin: 0,
                    authorization: null,
                },
            };
        } else if (cryptojs.isEncode(json?.data?.lineState)) {
            const decodeParams = cryptojs.decode(json?.data?.lineState);
            from = {
                path: decodeParams.path,
                params: decodeParams.params,
                data: {
                    ...decodeParams?.data,
                    autoLogin: 0,
                    authorization: null,
                },
            };
        }

        encodeParams = cryptojs.encode(from);

        // redirect
        EXPPopupJs.alert({
            type: 'warning',
            icon: 'warning',
            title: 'เกิดข้อผิดพลาด',
            message: json.rejectReason,
            classNames: { message: 'font-detail2' },
            buttons: [
                {
                    label: 'ตกลง',
                    variant: 'primary',
                    action: () => {
                        window.location.assign(redirectPath + encodeParams);
                    },
                },
            ],
        });
    }

    // Token Expired
    if (json.statusCode === 408 && ['/service/telepharmacy', '/service/telemed'].every((e) => window.location.pathname !== e)) {
        console.error(json);
        //
        let encodeParams = '';
        let from: DecodeFromData = {
            path: '/',
            params: '',
        };
        const query = paramsToObject(window.location.search);
        //
        if (window.location.pathname.startsWith('/user/sso') && query.pcparam) {
            const decodeParams = cryptojs.decode(query.pcparam);

            if (!isMobile && decodeParams?.data?.userType === 'SSO') {
                redirectPath = window.location.href;
            } else if (
                decodeParams?.data?.partner === '34' &&
                decodeParams?.data?.userType === 'SSO' &&
                isMobile &&
                !(isIOS && osVersion <= '14.3.0') &&
                !IS_IN_APP_WEBVIEW_BROWSER.some((e) => e === browserName) &&
                window.location.pathname.startsWith('/user/sso')
            ) {
                let nextPath = window.location.href;
                let url = window.encodeURIComponent(nextPath);

                const pharmcarePath = url;
                // redirectPath =
                //     'https://workplaze.page.link/?link=https://workplaze.page.link/' +
                //     pharmcarePath +
                //     '&apn=com.hmc.workplaze&isi=1637565364&ibi=com.hmc.workplaze'
                redirectPath =
                    'workplaze://myplaze/marketplace/health?link=' +
                    pharmcarePath +
                    '&apn=com.hmc.workplaze&isi=1637565364&ibi=com.hmc.workplaze';
            }
        } else if (
            json?.userProfile?.userXPartner &&
            json?.userProfile?.userXPartner.partnerTheme === 'workplaze' &&
            isMobile &&
            !IS_IN_APP_WEBVIEW_BROWSER.some((e) => e === browserName) &&
            json?.userProfile?.userType === 'SSO'
        ) {
            from = {
                path: '/phr/existing',
                data: {
                    partner: '34',
                    userType: 'SSO',
                    authorization: null,
                    userId: null,
                    autoLogin: '1',
                    companyCode: '',
                    language: 'TH',
                    rich: null,
                    theme: json?.userProfile?.userXPartner?.partnerTheme,
                },
            };

            if (query.pcparam) {
                from = {
                    ...from,
                    ...cryptojs.decode(query.pcparam),
                };
            }
            if (query?.language) {
                from = {
                    ...from,
                    data: {
                        ...from.data,
                        language: query?.language?.toLocaleUpperCase(),
                    },
                };
            }
        } else if (window.location.pathname === '/line/redirect') {
            let to = query?.to || '';

            if (query['liff.state']) {
                const decodeUri = window.decodeURIComponent(query['liff.state']);
                const liffState = paramsToObject(decodeUri);

                to = liffState?.to || '';
            }

            if (cryptojs.isEncode(to)) {
                const decodeParams = cryptojs.decode(to);

                from = {
                    path: decodeParams.path,
                    params: decodeParams.params,
                    data: {
                        ...decodeParams?.data,
                        authorization: null,
                        theme: json?.userProfile?.userXPartner?.partnerTheme || 'default',
                    },
                };
            }
        } else if (window.location.pathname === '/partner20/redirect/user-plugin') {
            const decodeLineState = cryptojs.decode(json?.userProfile?.lineState);

            let paramsLiffState = window.location.search;

            if (query['liff.state']) {
                paramsLiffState = window.decodeURIComponent(query['liff.state']);
            }

            from = {
                path: '/tlm/claim',
                params: paramsLiffState,
                data: {
                    ...decodeLineState?.data,
                    partner: '20',
                    autoLogin: 0,
                    authorization: null,
                    theme: json?.userProfile?.userXPartner?.partnerTheme || 'default',
                },
            };
        } else if (cryptojs.isEncode(json?.userProfile?.lineState)) {
            const decodeParams = cryptojs.decode(json?.userProfile?.lineState);
            from = {
                path: window.location.pathname,
                params: window.location.search || '',
                data: {
                    ...decodeParams?.data,
                    autoLogin: 0,
                    authorization: null,
                    theme: json?.userProfile?.userXPartner?.partnerTheme || 'default',
                },
            };
        }

        clearUserLocalStorage();

        encodeParams = cryptojs.encode(from);
        if (
            process.env.REACT_APP_POPUP_ALERT_THEME_WORKPLAZE === 'true' &&
            ((json?.userProfile?.userXPartner && json?.userProfile?.userXPartner.partnerTheme === 'workplaze') || query.pcparam)
        ) {
            alert('browserName: ' + browserName);
            alert(redirectPath + encodeParams);
        }
        // redirect
        window.location.assign(redirectPath + encodeParams);
    }

    if (json.statusCode === 407 || json.statusCode === 417 || json.statusCode === 500) {
        console.error(json);

        EXPPopupJs.alert({
            icon: 'warning',
            title: 'เกิดข้อผิดพลาด',
            message: 'เนื่องจากระบบล่ม กรุณาติดต่อ PharmCare',
            buttons: [
                {
                    label: 'ตกลง',
                    variant: 'danger',
                    action: ({ close }) => {
                        reject({ ...json, isNoPopup: false });
                        close();
                    },
                },
            ],
        });
        if (requestPath === '/misc/ui-theme-config') reject({ ...json, isError: true });
        if (requestPath === '/user/validateToken') reject({ ...json, isNoPopup: false });
    }
}
